(function() {
    'use strict';
    

a3_cabin_reports.config(localStorageMD5Config)

    /**
    * @memberof CabinReports
    * @ngdoc config
    * @name localStorageMD5Config
    * @description 
    *   Config localStorageMD5ServiceProvider directly by using localStorageMD5ServiceProvider
    * @ngInject
    */
function localStorageMD5Config(localStorageMD5ServiceProvider, localStorageServiceProvider) {
    //localStorageMD5ServiceProvider.help();
    var regx = /[?&]secure[&#]?/;
    if (regx.exec(window.location.href)) {
        console.log('*** SECURE MODE ***');
        localStorageServiceProvider.setStorageType('sessionStorage');
    }
    localStorageServiceProvider.setPrefix('a3.cabin.reports');
    localStorageServiceProvider.setStorageCookie(10, '/');
    localStorageMD5ServiceProvider.enableCompression();
}
    
})();